
  import {defineComponent} from "vue";
  import paycoUtils from "@/assets/js/utils";

  export default defineComponent({
    name: 'product-usage-component',
    props: ['product', 'isForTicketDetail'],
    computed: {
      cautionList(): Array<string> {
        if (paycoUtils.isEmptyString(this.product?.caution)) {
          return [];
        }
        return paycoUtils.splitByNewline(this.product?.caution);
      },
      contactLink(): string {
        return 'tel:' + (this.product?.contactUsTel ?? '');
      }
    }
  });
